import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { PresentationCard } from './components/Card/PresentationCard';
import { getPresentationPagedOptions } from './model/PresentationQuery';

export function PresentationBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getPresentationPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('presentations.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('presentations.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('presentations.sortedByTitle')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={presentation => (
        <PresentationCard
          key={presentation.id}
          presentation={presentation}
          to={`${presentation.id}`}
        />
      )}
    />
  );
}
